import { DateTime } from "luxon";

/** ISO string (SSE) or an already-converted Luxon DateTime (axios /replan + resume) → dept-tz DateTime. */
export const toAnniePickupDepartmentTime = (value: string | DateTime | null, timezone: string): DateTime | null => {
	if (value === null) return null;
	const dateTime = typeof value === "string" ? DateTime.fromISO(value) : value;
	if (!dateTime.isValid) return null;
	// Guard against an empty/invalid tz before the department resolves.
	const zoned = dateTime.setZone(timezone);
	return zoned.isValid ? zoned : null;
};
